import { TruncatedTextCell } from '@/creditflowresearch/ui/common/components/DataCells';

interface IParentCellProps {
  parent: { id: string, name: string } | null | undefined,
}

const ParentCell = ({ parent }: IParentCellProps) => {
  if (!parent?.name) {
    return (<>-</>);
  }

  return <TruncatedTextCell value={ parent.name } />;
};

export default ParentCell;
